import Sidebar from "@/components/Sidebar";
import DemoBanner from "@/components/DemoBanner";
import { useAuth } from "@/contexts/AuthContext";
import { Bell } from "lucide-react";

export default function Layout({ children, title, subtitle, actions }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-canvas">
      <Sidebar />
      <div className="md:pl-[260px] flex flex-col min-h-screen">
        <DemoBanner />
        <header className="sticky top-0 z-20 h-16 border-b border-tertiary bg-white/85 backdrop-blur-md print:hidden">
          <div className="h-full px-6 sm:px-8 flex items-center justify-between gap-4">
            <div className="min-w-0">
              {title && <h1 className="font-heading text-xl sm:text-2xl font-extrabold tracking-tight text-ink-900 truncate" data-testid="page-title">{title}</h1>}
              {subtitle && <p className="text-xs text-ink-500 truncate">{subtitle}</p>}
            </div>
            <div className="flex items-center gap-3">
              {actions}
              <button className="p-2 rounded-md text-ink-500 hover:bg-ink-200/40 transition-colors" aria-label="Notificações">
                <Bell size={18} />
              </button>
              <div className="hidden sm:flex items-center gap-2 pl-3 border-l border-tertiary">
                <div className="w-8 h-8 rounded-full bg-brand-500 text-white flex items-center justify-center font-semibold text-sm">
                  {(user?.name || user?.email || "?").slice(0, 1).toUpperCase()}
                </div>
                <div className="text-xs leading-tight">
                  <div className="font-semibold text-ink-900">{user?.name || "Usuário"}</div>
                  <div className="text-ink-500 capitalize">{user?.role}</div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 p-6 sm:p-8 animate-fade-in">{children}</main>
      </div>
    </div>
  );
}
